// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3ds_N","selected":"Chip_selected__32YQL"};